<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <!-- <v-btn color="primary" text rounded x-small> Focusing at </v-btn> -->
          <span class="caption">
            <b>Focusing Targets: </b
            ><span class="linkLike">
              <span v-if="allSelected">All distances</span>
              <span v-else>{{ selectedTitles.join(", ") }}</span></span
            >
          </span>
          <v-icon small color="primary" class="ml-2">mdi-pencil</v-icon>
        </div>
      </template>

      <v-card>
        <v-card-title
          class="text-h5 orangeCardTitle d-flex flex-row align-center"
        >
          <div>Choose Objects to Focus On</div>
          <v-spacer></v-spacer>
          <v-btn small icon @click="doClose()">
            <v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>

        <v-card-text class="pt-4">
          <div class="justify-end d-flex">
            <v-btn x-small depressed @click="selectAll" color="primary" outlined
              >Select All</v-btn
            >
          </div>
          <v-list flat subheader two-line class="mt-4">
            <v-list-item-group
              v-model="selectedItems"
              multiple
              active-class="orangeActive"
            >
              <v-list-item v-for="(obj, key) in items" :key="key">
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-icon>
                    <v-img
                      :src="imgRoot + obj.src"
                      contain
                      width="30"
                      class="mr-3"
                    ></v-img>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ obj.label }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      metric ? obj.distance_metric : obj.distance
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <!-- {{ selectedObjects }} -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="d-flex flex-row align-center">
          <v-fade-transition>
            <v-alert v-if="selectedItems.length == 0" type="error" dense>
              Please select at least one item.</v-alert
            ></v-fade-transition
          >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="doClose()"
            :disabled="selectedItems.length == 0"
            >Select</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";
import VsDefinitions from "./VsDefinitions";

export default {
  name: "LookingAtSelector",
  props: { metric: null },
  mixins: [VsDefinitions],
  data: function () {
    return {
      dialog: false,
      selectedItems: [],
      defaultSelected: [0, 3],
      imgRoot: "https://www.eyedock.com/images/visionSimulator/",
    };
  },
  methods: {
    selectAll() {
      this.selectedItems = [...Array(this.itemKeys.length).keys()];
    },
    doClose() {
      this.dialog = false;
      this.doEmit();
    },
    doEmit() {
      this.$emit("focusItems", this.selectedObjects);
    },
  },
  computed: {
    items: function () {
      return VsDefinitions.lookingAtData;
    },
    itemKeys: function () {
      return Object.keys(this.items);
    },
    allSelected: function () {
      return this.selectedItems.length === this.itemKeys.length;
    },
    // selectedKeys: function () {
    //   return this.selectedItems.map((i) => this.itemKeys[i]);
    //   },
    selectedTitles: function () {
      return this.selectedItems.map((i) => this.items[this.itemKeys[i]].label);
    },
    selectedObjects: function () {
      let rtn = {};
      // clone selecteditems array then put the result in numerical order
      let keys = this.selectedItems.slice().sort((a, b) => a - b);
      // let keys =this.selectedItems.sort((a, b) => a - b);
      keys.forEach((i) => {
        let key = this.itemKeys[i];
        let obj = this.items[key];
        rtn[key] = obj;
      });
      return rtn;
    },
  },
  mounted() {
    // i want to populate the selectedItems an array from 0 to the length of the itemskeys array
    this.selectedItems = this.defaultSelected;
    this.doEmit();
  },
};
</script>

<style scoped></style>
